module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header'), _vm._v(" "), _c('div', {
    staticClass: "mt-70"
  }, [_c('v-container', {
    attrs: {
      "grid-list-xl": "",
      "pt-0": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "col-height-auto",
    attrs: {
      "xs12": "",
      "md12": "",
      "lg12": "",
      "sm12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md7": "",
      "lg8": ""
    }
  }, [_c('v-card', {
    staticClass: "mb-3"
  }, [_c('v-img', {
    attrs: {
      "height": "200",
      "src": "https://t3.ftcdn.net/jpg/02/28/15/94/240_F_228159438_ws17802otLr1ZG9SK2ga7ducWtwrt2tg.jpg"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": "",
      "fluid": "",
      "pa-2": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "headline white--text ml-3",
    domProps: {
      "textContent": _vm._s(_vm.telegramName)
    }
  })])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_vm._l((_vm.telegramGroupList), function(item, index) {
    return [_c('div', {
      key: index,
      staticClass: "mt-3 mb-3 ml-3 mr-3"
    }, [_c('v-avatar', {
      staticClass: "pointer",
      attrs: {
        "color": "primary",
        "size": "40"
      },
      on: {
        "click": function($event) {
          return _vm.viewUserTelegramInfo(item.userName)
        }
      }
    }, [(item.photoUrl) ? _c('img', {
      attrs: {
        "src": item.photoUrl
      }
    }) : _c('span', {
      staticClass: "white--text headline"
    }, [_c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.firstName != null),
        expression: "item.firstName != null"
      }]
    }, [_vm._v(_vm._s(item.firstName != null ? item.firstName.trim().substring(0, 1) : ''))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.firstName == null && item.lastName != null),
        expression: "item.firstName == null && item.lastName != null"
      }]
    }, [_vm._v(_vm._s(item.lastName != null ? item.lastName.trim().substring(0, 1) : ''))]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.firstName == null && item.lastName == null && item.userName != null),
        expression: "item.firstName == null && item.lastName == null && item.userName != null"
      }]
    }, [_vm._v(_vm._s(item.userName != null ? item.userName.trim().substring(0, 1) : ''))])])]), _vm._v(" "), _c('span', {
      staticClass: "ml-3 pointer hover-color",
      on: {
        "click": function($event) {
          return _vm.viewUserTelegramInfo(item.userName)
        }
      }
    }, [(item.firstName != null) ? _c('span', {
      staticClass: "fw-bold font-lg"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.firstName != null ? item.firstName : '') + " " + _vm._s(item.lastName != null ? item.lastName : '') + "\n\t\t\t\t\t\t\t\t\t\t\t")]) : _c('span', [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.userName != null ? item.userName : '') + "\n\t\t\t\t\t\t\t\t\t\t\t")])]), _vm._v(" "), _c('span', {
      staticClass: "ml-3 fw-bold font-14"
    }, [_c('v-icon', {
      attrs: {
        "size": "18"
      }
    }, [_vm._v("schedule")]), _vm._v("  \n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(_vm.dateFormat(parseInt(item.date * 1000))) + "\n\t\t\t\t\t\t\t\t\t\t")], 1), _vm._v(" "), _c('div', {
      staticClass: "mt-3 ml-5 pl-2 font-md fw-400 overflow-hidden"
    }, [_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t" + _vm._s(item.text) + "\n\t\t\t\t\t\t\t\t\t\t")])], 1)]
  })], 2), _vm._v(" "), _c('keep-alive', [_c('infinite-loading', {
    ref: "infiniteLoading",
    staticClass: "mb-3",
    attrs: {
      "identifier": _vm.changeDate
    },
    on: {
      "infinite": _vm.findTelegramUserMsg
    }
  }, [_c('div', {
    attrs: {
      "slot": "spinner"
    },
    slot: "spinner"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-more"
    },
    slot: "no-more"
  }, [_vm._v("noMore")]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "no-results"
    },
    slot: "no-results"
  }, [_vm._v("noResults")])])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md1": "",
      "lg4": ""
    }
  }, [_c('app-right')], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e799a56c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/user/TelegramUserMessages.vue
// module id = 472
// module chunks = 0